import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  Breadcrumbs,
  BreadcrumbsProps,
} from "../common/breadcrumbs/Breadcrumbs";
import Button, { ButtonProps } from "../common/Buttons/Button";
import Title from "../common/Title/Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { headerPageClasses } from "./headerPage.styles";

export type ExtraAction = Omit<
  ButtonProps,
  "onClick" | "size" | "children" | "icon" | "label"
> & {
  label: string;
  icon?: IconProp;
  onClick: () => void;
  actionKey: string;
};

type HeaderPageProps = {
  title: string;
  subTitle?: string;
  onNew?: () => void;
  breadcrumbItems?: BreadcrumbsProps["items"];
  extraActions?: ExtraAction[];
};

export const HeaderPage = (props: HeaderPageProps) => {
  const { title, subTitle, onNew, breadcrumbItems, extraActions } = props;
  const classes = headerPageClasses(!!subTitle);
  const showActionsRow = !!onNew || !!extraActions?.length || !!subTitle;
  return (
    <>
      <Title title={title} />
      {breadcrumbItems && <Breadcrumbs items={breadcrumbItems} />}
      {showActionsRow && (
        <div className={classes.subHeaderContainer}>
          {subTitle && (
            <div className="mb-2 md:mb-0">
              <Title title={subTitle} variant="h2" />
            </div>
          )}
          <div className={classes.actions}>
            {onNew && (
              <Button size="medium" onClick={onNew} color="primary">
                Nuevo
              </Button>
            )}
            {extraActions?.map(({ label, icon, ...rest }) => (
              <Button size="medium" {...rest}>
                {icon && (
                  <>
                    <FontAwesomeIcon icon={icon} />{" "}
                  </>
                )}
                {label}
              </Button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};
